import { render, staticRenderFns } from "./myFinished.vue?vue&type=template&id=36d5b39d&scoped=true&lang=pug"
import script from "./myFinished.vue?vue&type=script&lang=js"
export * from "./myFinished.vue?vue&type=script&lang=js"
import style0 from "./myFinished.vue?vue&type=style&index=0&id=36d5b39d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d5b39d",
  null
  
)

export default component.exports